import React, { useState } from "react";
import WebSkull from "../../images/WebSkull.png";
import WebTitle from "../../images/GunxWebTitle.png";
import CreditTitle from "../../images/CreditTitle.png";
import useInterval from "../../Scripts/useInterval";
import { bigNumAsInt } from "../../Scripts/bigNumAsInt";
import { ethers, BigNumber } from "ethers";
import { useMetamask } from "../../Scripts/UseMetamask";
import { contractAddress } from "../../AppCustomisation/dAPPCustomisation.js";
import Contract from "../../AppCustomisation/mainContractABI.json";
import GeneralMint from "../../Scripts/GeneralMint";
import WhitelistMint from "../../Scripts/WhitelistMint";
import TotalSupply from "./totalSupply";
import MusicPlayer from '../../MusicPlayer/MusicPlayer';
import {
  HeroContainer,
  HeroContent,
  ImageBg,
  ImageHeader,
  PreviewImage,
  PreviewImage2,
  UserWrapper,
  HeroH1,
  HeroP3,
  SupplyP2,
  BlankDiv,
  HeroP2,
  PreviewImage3
} from "./HeroElements";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function HeroSection() {
  const [hover, setHover] = useState(false);
  const [isMintOpen, setIsMintOpen] = useState(false);
  const [isPublicMintOpen, setIsPublicMintOpen] = useState(false);

  const { account, provider, signer } = useMetamask();

  const handleFetchIsMintOpen = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const isMintOpen = await contract._openMint();
      setIsMintOpen(isMintOpen);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFetchIsPublicMintOpen = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const isPublicMintOpen = await contract._openPublicMint();
      setIsPublicMintOpen(isPublicMintOpen);
      console.log(isPublicMintOpen)
    } catch (err) {
      console.log(err);
    }
  };

  useInterval(() => {
    handleFetchIsMintOpen();
  }, 5000);

  useInterval(() => {
    handleFetchIsPublicMintOpen();
  }, 5000);
  
  const onHover = () => {
    setHover(!hover);
  };
  return (
    <HeroContainer>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <HeroContent id="mint">
        <ImageBg>
          <PreviewImage src={WebSkull} />
        </ImageBg>
        <UserWrapper>
          <ImageHeader>
            <PreviewImage2 src={WebTitle} />
          </ImageHeader>
          {isMintOpen ? <TotalSupply/> : <BlankDiv/> }
          {account ? (
            isMintOpen ? (
              isPublicMintOpen ? <GeneralMint/> : <WhitelistMint/>
            ):(<HeroP2>Minting is not currently open</HeroP2>)
          ):(<HeroP2>Connect to the FTM Network to mint your NFTs</HeroP2>)}
          <HeroP3>1 X NFT = 60 FTM</HeroP3>
          <SupplyP2>ALL TRANSACTIONS ARE FINAL</SupplyP2>
          <ImageHeader>
            <PreviewImage3 src={CreditTitle} />
          </ImageHeader>
        </UserWrapper>
      </HeroContent>
      <MusicPlayer/>
    </HeroContainer>
  );
}

export default HeroSection;
